import axios from 'axios'
import authHeader from './auth-header'

class EmbaixadoresService {

  postIndicacaoEmbaixadores ( payload ) {
    return axios.post(process.env.VUE_APP_API_URL + 'embaixadores/indicacao', payload, { headers: authHeader() })
  }

}

export default new EmbaixadoresService()